import {AbstractLitElement} from "../abstract-lit.element";
import {property} from "lit/decorators/property.js";
import type {PropertyInfo} from "../../types/property-info.type";


export abstract class AbstractViewerComponent<TValueType, TSettings extends Record<string, any> = Record<string, any>> extends AbstractLitElement {

    @property({type: Object})
    public value: TValueType | Array<TValueType> | undefined | null = null;

    @property({type: Object})
    public propertyInfo!: PropertyInfo;

    @property({type: Object})
    public settings: TSettings | null = null;

}